import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CmsConfig, provideConfig } from '@spartacus/core'
import { GenericLinkModule } from '@spartacus/storefront'
import { EbParagraphComponent } from './eb-paragraph.component'

@NgModule({
  imports: [CommonModule, GenericLinkModule],
  providers: [
    provideConfig({
      cmsComponents: {
        CMSParagraphComponent: {
          component: EbParagraphComponent
        }
      }
    } as CmsConfig)
  ],
  declarations: [EbParagraphComponent]
})
export class EbParagraphModule {}
